import { HOC_MDXWrapper } from 'nextra/setup-page'
import { pageMap } from '/vercel/path0/.next/static/chunks/nextra-page-map-.mjs'
/*@jsxRuntime automatic*/
/*@jsxImportSource react*/
import {useMDXComponents as _provideComponents} from "nextra/mdx";
const title = "Introduction";
const frontMatter = {
  "title": "Introduction",
  "description": "Pluto — The API for personal web data. Embed it in your app to authenticate users, share data and perform actions on their behalf for any site on the internet."
};
import ExpandGettingStarted from "../components/ExpandSidebar";
export function useTOC(props) {
  return [{
    value: "Introduction",
    id: "introduction",
    depth: 2
  }, {
    value: "What is Pluto?",
    id: "what-is-pluto",
    depth: 3
  }, {
    value: "Who is the audience for these docs?",
    id: "who-is-the-audience-for-these-docs",
    depth: 3
  }, {
    value: "Where to get help?",
    id: "where-to-get-help",
    depth: 3
  }];
}
function MDXLayout(props) {
  const {toc = useTOC(props)} = props;
  const _components = {
    a: "a",
    h2: "h2",
    h3: "h3",
    li: "li",
    p: "p",
    strong: "strong",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  };
  return <><_components.h2 id={toc[0].id}>{toc[0].value}</_components.h2>{"\n"}<_components.h3 id={toc[1].id}>{toc[1].value}</_components.h3>{"\n"}<_components.p>{"Pluto is an API for any web data. Embed Pluto into your app to authenticate users, share data, and perform actions on users’ behalf for any site on the internet."}</_components.p>{"\n"}<_components.p>{"There are 3 major components to Pluto:"}</_components.p>{"\n"}<_components.ul>{"\n"}<_components.li>{"Embedded Automations, which power automated actions for users"}</_components.li>{"\n"}<_components.li>{"Pluto Frame, which is an integrated component for adding authenticated Embedded Automations into your application"}</_components.li>{"\n"}<_components.li>{"Pluto Functions, which can execute arbitrary JS functions to retrieve and compute over data"}</_components.li>{"\n"}</_components.ul>{"\n"}<_components.p>{"Embedded Automations and Functions receive a signed attestation of correct execution from our secure infrastructure, which can be verified locally."}</_components.p>{"\n"}<_components.p>{"Pluto runs on secure infrastructure and uses best-in-class encryption."}</_components.p>{"\n"}<_components.h3 id={toc[2].id}>{toc[2].value}</_components.h3>{"\n"}<_components.p>{"This documentation is intended for "}<_components.strong>{"developers interested in integrating Pluto into their applications"}</_components.strong>{". These docs will assume some degree of technical knowledge."}</_components.p>{"\n"}<_components.h3 id={toc[3].id}>{toc[3].value}</_components.h3>{"\n"}<_components.p>{"If you want to get in touch with the Pluto team directly, join the community Telegram group "}<_components.a href="https://t.me/pluto_xyz">{"at this link"}</_components.a>{" or DM the "}<_components.a href="https://x.com/plutolabs_">{"Pluto account on Twitter"}</_components.a>{"."}</_components.p>{"\n"}{"\n"}<ExpandGettingStarted /></>;
}


export default HOC_MDXWrapper(
  MDXLayout,
  '/',
  {"filePath":"pages/index.mdx","timestamp":1750278560000,pageMap,frontMatter,title},
  typeof RemoteContent === 'undefined' ? useTOC : RemoteContent.useTOC
)